import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/common';

/**
 * 共通のState型
 */
export interface ICommonState {
	readonly errorMessage: IErrorMessageState;
}

/**
 * エラーメッセージのState型
 */
export interface IErrorMessageState {
	readonly open: boolean;
	readonly withLogout: boolean;
	readonly content: string;
	readonly replacements: string[];
	readonly transitionTo?: string;
}

/**
 * 共通のState初期値
 */
const initialState: ICommonState = {
	errorMessage: {
		content: '',
		open: false,
		replacements: [],
		transitionTo: void 0,
		withLogout: false,
	},
};

/**
 * 共通reducer
 * @param state ログイン情報
 * @param action アクション
 */
const common = (state: ICommonState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	// 認証エラー
	if (isType(action, Actions.commonHandleAuthError)) {
		return {
			...state,
			errorMessage: {
				content: 'LGN_E_0001',
				open: true,
				replacements: [],
				withLogout: true,
			},
		};
	}

	// セッションタイムアウト
	if (isType(action, Actions.commonHandleSessionTimeout)) {
		return {
			...state,
			errorMessage: {
				content: 'LGN_E_0002',
				open: true,
				replacements: [],
				withLogout: true,
			},
		};
	}

	// 排他エラー
	if (isType(action, Actions.commonHandleExclusionError)) {
		return {
			...state,
			errorMessage: {
				content: 'COM_E_0001',
				open: true,
				replacements: [],
				withLogout: false,
			},
		};
	}

	// 業務エラー
	if (isType(action, Actions.commonHandleShowErrorMessage)) {
		const { content, replacements, transitionTo } = action.payload;
		return {
			...state,
			errorMessage: {
				content,
				open: true,
				replacements: replacements !== void 0 ? replacements : [],
				transitionTo,
				withLogout: false,
			},
		};
	}

	// 非表示
	if (isType(action, Actions.commonHideErrorMessage)) {
		return {
			...state,
			errorMessage: {
				content: '',
				open: false,
				replacements: [],
				transitionTo: void 0,
				withLogout: false,
			},
		};
	}

	return state;
};

export default common;



// WEBPACK FOOTER //
// ./src/reducers/common.ts